import angular from 'angular';
import template from './modal-disabled-camera.html';
import './modal-disabled-camera.scss';
import * as devices from '../../../../modules/devices';
class MobileModalDisabledCameraController {
    constructor(Browser, $ngRedux) {
        this.Browser = Browser;
        this.$ngRedux = $ngRedux;
    }
    $onInit() {
        this.articleUrl = this.Browser.getHelpArticleUrl();
    }
    hide() {
        this.$ngRedux.dispatch(devices.actions.closeModalDisableCamera());
    }
}
const mobileModalDisabledCamera = {
    template,
    bindings: {},
    controller: MobileModalDisabledCameraController,
};
export default angular
    .module('doxy.videoChat.common.modals.mobile.modalDisabledCamera', [])
    // modal-disabled-camera
    .component('modalDisabledCamera', mobileModalDisabledCamera).name;
